export const SET_CUSTOMIZACAO_HIBRIDO = 'SET_CUSTOMIZACAO_HIBRIDO'

const COR_PADRAO_HIBRIDO = '#616161'

const initialState = () => ({
  loading: false,
  nomeClinica: null,
  urlLogoHibrido: null,
  colorThemeHibrido: COR_PADRAO_HIBRIDO,
  snackbar: {
    value: false,
    color: '',
    text: ''
  }
})

const state = initialState()

const mutations = {
  RESET: state => {
    Object.assign(state, initialState())
  },
  SET_LOADING: (state, payload) => {
    state.loading = payload
  },
  SET_SNACKBAR: (state, { value, color, text }) => {
    state.snackbar = { value, color, text }
  },
  HIDE_SNACKBAR: state => {
    state.snackbar.value = false
  },
  SET_NOME_CLINICA: (state, payload) => {
    state.nomeClinica = payload
  },
  [SET_CUSTOMIZACAO_HIBRIDO]: (state, { urlLogo, colorTheme } = {}) => {
    state.urlLogoHibrido = urlLogo || null
    state.colorThemeHibrido = colorTheme || COR_PADRAO_HIBRIDO
  }
}

const getters = {
  urlLogoHibrido: state => state.urlLogoHibrido,
  colorThemeHibrido: state => state.colorThemeHibrido
}

const actions = {
  showLoading: ({ commit }) => {
    commit('SET_LOADING', true)
  },
  hideLoading: ({ commit }) => {
    commit('SET_LOADING', false)
  },
  showSuccessMessage: ({ commit }, text) => {
    commit('SET_SNACKBAR', {
      value: true,
      color: 'success',
      text
    })
  },
  showErrorMessage: ({ commit }, text) => {
    commit('SET_SNACKBAR', {
      value: true,
      color: 'error',
      text: text || 'Erro! Entre em contato com nosso time'
    })
  },
  hideMessage: ({ commit }) => {
    commit('HIDE_SNACKBAR')
  }
}

export default { namespaced: true, state, mutations, actions, getters }
